export default __webpack_public_path__ + "media/img-1.525baf9a.png";